import React, { useState} from 'react';
import { UrlCheckHelper } from '../../../../_helpers/UrlCheckHelper';
import { Editor } from '@tinymce/tinymce-react';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin.min.css';
import ButtonText from '@visa/vds/button-text';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Input from '@visa/vds/input';

function AnnouncementEditor(props) {

    const [invalidLink, setInvalidLink] = useState(false);
    const [showUrlEditor, setShowUrlEditor] = useState(false);
    const [invalidAnnouncementLength, setInvalidAnnouncementLength] = useState(false);

    const updateAnnouncementLength = () => {
        if (props.editorRef.current && props.editorRef.current.getContent().length > 2995) {
            setInvalidAnnouncementLength(true)
        }
        else {
            setInvalidAnnouncementLength(false)
        }
    };

    return(
    <Row noGutter key={2}>
        <Col noTopGutter noGutter lg={12}>
            <p style={{color:"#616188",marginBottom:"4px"}}>Announcement Details</p>
            {(showUrlEditor == true) &&
                <>
                    <Input
                        className="editor-url"
                        style={{height:"22px"}}
                        name="url"
                        id="editor-insert-url"
                        placeholder="Type the link to add"
                        invalid={invalidLink}
                    />
                    <ButtonText
                        colorScheme="secondary"
                        style={{minHeight:"19px",width:"60px",fontSize:"13px"}}
                        onClick={() => {
                            if (document.getElementById('editor-insert-url') == null) {
                                return;
                            }
                            let content = tinymce.activeEditor.selection.getContent({ format: 'text' });
                            let hyperlink = document.getElementById('editor-insert-url').value.trim();
                            if (hyperlink != "") {
                                if (UrlCheckHelper.CheckUrl(hyperlink) == false) {
                                    setInvalidLink(true);
                                    return;
                                } else {
                                    setInvalidLink(false);
                                    if (!hyperlink.startsWith("http")) {
                                        hyperlink = 'https://' + hyperlink.trim();
                                    }
                                }
                                if (content != "") {
                                    content = '<a title ="' + hyperlink + '" href="' + hyperlink + '" target="_blank" rel="noopener">' + content + '</a>';
                                }
                                else {
                                    content = '<a title ="' + hyperlink + '" href="' + hyperlink + '" target="_blank" rel="noopener">' + document.getElementById('editor-insert-url').value + '</a>';
                                }
                                tinymce.activeEditor.selection.setContent(content);
                            }
                            
                           setShowUrlEditor(false)
                        }}>Confirm</ButtonText>

                    <ButtonText
                        colorScheme="secondary"
                        style={{minHeight:"19px",width:"60px",fontSize:"13px"}}
                        onClick={() => {
                            setInvalidLink(false);
                            setShowUrlEditor(false);
                        }}>Cancel</ButtonText>
                </>
            }
            {(invalidLink == true) &&
                <p style={{fontSize:"13px",color:"#D50000"}}>This link is invalid. Please try again.</p>
            }

            <Editor
                onInit={(evt, editor) => {
                        props.editorRef.current = editor
                }}
                initialValue={props.value}
                onEditorChange={updateAnnouncementLength}
                init={{
                    license_key: 'gpl',
                    skin: false,
                    menubar: false,
                    toolbar: 'undo redo|' +
                        'bold italic underline removeformat| ' +
                        'addurl removeurl',
                    content_style: 'body { font-family:OpenSans,sans-serif; font-size:16px }',
                    branding: false,
                    elementpath: false,
                    statusbar: true,
                    height: 140,
                    setup: function (editor) {
                        editor.ui.registry.addButton('addurl', {
                            icon: 'link',
                            tooltip: 'Insert/Edit Link',
                            onAction: function (_) {
                                setShowUrlEditor(true);
                                if (document.getElementById('editor-insert-url')) {
                                    document.getElementById('editor-insert-url').focus();
                                }
                            }
                        });

                        editor.ui.registry.addButton('removeurl', {
                            icon: 'unlink',
                            tooltip: 'Remove Link',
                            onAction: function (_) {
                                let content = tinymce.activeEditor.selection.getContent({ format: 'text' });
                                editor.insertContent(content);
                            }
                        });
                    }
                }}
            />
            {(invalidAnnouncementLength == true) &&
                <p style={{fontSize:"13px",color:"#D50000"}}>You have exceeded the maximum character count.</p>
            }
        </Col>
    </Row>
    );

}

export default AnnouncementEditor